import React from 'react';
import {Navigate, useParams} from 'react-router-dom';
import marketing01 from '../../assets/img/marketing01.webp';
//import { Swiper, SwiperSlide } from "swiper/react";
//import { FreeMode, Scrollbar, Mousewheel } from "swiper";
/*import SwiperCore, {
     Pagination, Navigation,
} from 'swiper/core';*/
//import { EffectCoverflow} from "swiper";
import TopTitleBlock from '../../Components/TopTitleBlock/TopTitleBlock';
import styles from './Marketing.module.scss';
import {useGetNewsViewQuery} from '../../redux/newsApi';
import Loader from '../../assets/Animations/PreLoaderComponent/Loader';
import PreLoaderComponent from '../../assets/Animations/PreLoaderComponent/PreLoaderComponent';
import CategoriesAndTags from '../MediaAndNews/CategoriesAndTags';
// install Swiper modules
//SwiperCore.use([ Pagination, Navigation,EffectCoverflow]);

const Marketing: React.FC = () => {
	const {newsId} = useParams();
	const newsIdNumber = Number(newsId);
	const {
		data: newsViewResp,
		isLoading,
		isError,
	} = useGetNewsViewQuery(newsIdNumber, {skip: !newsIdNumber});
	const newsView = newsViewResp && newsViewResp.approve ? newsViewResp : null;

	if (isLoading) {
		return <PreLoaderComponent type={'circle'} size={'big'} />;
	}
	if (isError || !newsView) {
		return <Navigate to={'/news'} />;
	}

	const parseList = (value: any) => {
		if (!value) return null;
		if (Array.isArray(value)) return value;
		if (typeof value === 'string') {
			try {
				const parsed = JSON.parse(value);
				return Array.isArray(parsed) ? parsed : null;
			} catch {
				return null;
			}
		}
		return null;
	};
	const newsTags = parseList((newsView as any)?.tags);
	const newsCategories = parseList((newsView as any)?.category);

	return (
		<div className="page__content">
			<TopTitleBlock title={newsView.topic} />
			<div className={styles.subTitle}>
				<div className={styles['subTitle__date']}>
					{newsView.published_date}
				</div>
				<div className={styles['subTitle__views']}>{newsView.count_viewed}</div>
			</div>

			<div className={`page__promotion ${styles.promotion}`}>
				{/*<div className={`promotion__top ${styles['top-promotion']}`}>
					<div className={styles['top-promotion__row']}>
						<div className={styles['top-promotion__column']}>
							<div className={styles['top-promotion__img-left']}>
								<img src={marketing01} alt="marketing_img" />
							</div>
						</div>
						<div className={styles['top-promotion__column']}>
							<div className={styles['top-promotion__img-right']}>
								<img src={newsView?.img} alt="marketing_img" />
							</div>
						</div>
					</div>
				</div>*/}

				<div className={`promotion__bottom ${styles['bottom-promotion']}`}>
					<div
						className={styles['bottom-promotion__text']}
						dangerouslySetInnerHTML={{__html: newsView?.text || ''}}
					/>
				</div>
			</div>
			<CategoriesAndTags newsTags={newsTags} newsCategories={newsCategories} />
		</div>
	);
};

export default Marketing;
